<template>
  <div class="header">
    <div class="header_box">
      <div
        @click="goHome()"
        class="logos"
      ><img
          src="../assets/logo.png"
          alt=""
        ></div>
      <div>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#409EFF"
          @select="handleSelect"
          router
        >
          <el-menu-item :index="'/navPage?searchForm='+JSON.stringify({pageNum:1,pageSize:3,goodsType:'',systemName:''})">搜索</el-menu-item>
          <el-menu-item :index="'/systemDemo?searchForm='+JSON.stringify({pageNum:1,pageSize:3,goodsType:1,systemName:''})">演示系统</el-menu-item>
          <el-menu-item :index="'/designScheme?searchForm='+JSON.stringify({pageNum:1,pageSize:3,goodsType:2,systemName:''})">设计方案</el-menu-item>
          <el-menu-item :index="'/publicPictures?searchForm='+JSON.stringify({pageNum:1,pageSize:3,goodsType:3,systemName:''})">宣传画册</el-menu-item>
          <el-menu-item :index="'/videoDemo?searchForm='+JSON.stringify({pageNum:1,pageSize:3,goodsType:4,systemName:''})">演示视频</el-menu-item>
          <el-menu-item :index="'/otherDemo?searchForm='+JSON.stringify({pageNum:1,pageSize:3,goodsType:5,systemName:''})">其他</el-menu-item>
        </el-menu>
      </div>
      <div class="to_center">
        <span @click="toCenter()">
          <el-avatar
            icon="el-icon-user-solid"
            title="个人中心"
          ></el-avatar>
        </span>
        <el-select
          v-if="loginFlag==true"
          v-model="value"
          placeholder=""
          @change="changeUser"
        >
          <el-option value="13012345678">{{userObj.phone}}</el-option>
          <el-option value="0"><i class="el-icon-s-home"></i> 退出</el-option>
        </el-select>
        <div
          v-else
          class="login"
          @click="login()"
        > 登 录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginUser } from "../js/api.js";
export default {
  data() {
    return {
      activeIndex: "/navPage",
      value: "13012345678",
      userObj: {},
      loginFlag: false,
      flag: false,
    };
  },
  created() {
    this.activeIndex = "/" + sessionStorage.getItem("routerFlag");

    this.loginUser();
  },
  methods: {
    goHome() {
      this.$router.push({ name: "index" });
    },
    //获取登录人信息
    async loginUser() {
      let res = await loginUser();
      if (res.data.code == 200) {
        if (res.data.data == null) {
          this.flag = false;
          this.userObj = {
            phone: "",
          };
        } else {
          this.flag = true;
          this.userObj = res.data.data;
          if (this.userObj.phone != null) {
            this.value = this.userObj.phone;
            this.loginFlag = true;
          } else {
            this.loginFlag = false;
          }
        }
      }
    },
    toCenter() {
      this.activeIndex = "";
      if (this.flag == true) {
        this.$router.push({ name: "myCenter" });
      } else {
        this.$message({
          showClose: true,
          message: "请先登录",
          type: "warning",
        });
      }
    },
    changeUser(e) {
      if (e == 0) {
        this.logout();
      }
    },
    login() {
      if (window.platform == undefined) {
        var http = "http://103.239.204.52:16000/index";
      } else {
        var http = `http://${window.platform.ip}:${window.platform.port}/index`;
      }
      window.location.href = http;
    },
    async logout() {
      if (window.platform == undefined) {
        var http = "http://103.239.204.52:16000/";
      } else {
        var http = `http://${window.platform.ip}:${window.platform.port}/`;
      }
      this.loginFlag = false;
      window.sessionStorage.clear();
      window.location.href = http + "/cas/logout";
    },
    handleSelect() {},
  },
};
</script>

<style scoped>
.header {
  height: 60px;
  z-index: 999;
  background: #091934;
  position: fixed;
  width: 100%;
}

.header_box {
  /* background: red; */
  width: 1200px;
  height: 60px;
  margin: auto;
  display: flex;
  align-items: center;
  position: relative;
}

.header_box > div {
  display: flex;
  align-items: center;
}
.header_box > div:first-child {
  margin-right: 50px;
}

.header_box > div:last-child {
  right: 0;
  position: absolute;
}

.header_box /deep/ .el-menu {
  background: transparent;
}

.header_box /deep/ .el-menu-item:hover {
  background: transparent;
  color: #fff !important;
}

.header_box /deep/ .is-active {
  background: transparent !important;
}

.el-avatar {
  margin-top: 3px;
}

.header_box /deep/.el-input__inner {
  background: transparent;
  border: none;
  color: #fff;
  width: 140px;
}

a {
  text-decoration: none;
}

.login {
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
}

.to_center {
  font-size: 16px;
  cursor: pointer;
}

.logos {
  cursor: pointer;
}
</style>